import { LogStyleOption } from '@models/custom-types.model';
import { environment } from 'src/environments/environment';

/**
 * Custom console logger with styling options.
 * @class Console
 */
export class Console {

  /**
   * Logs a message to the console with optional styling.
   * @param {string} label - The label for the log message.
   * @param {any} value - The value to log.
   * @param {LogStyleOption} style - 'std', 'warn','err' The style option for the log message.
   */
  static log(label: string, value: any, style: LogStyleOption = 'std') {
    // Se ENABLE_CONSOLE_LOGS è false, non loggare nulla
    if (!environment.ENABLE_CONSOLE_LOGS) {
      return;
    }

    const time = new Date().toLocaleTimeString();
    try {
      const styles = {
        std: '',
        succ: 'background: darkgreen; color: white;',
        info: 'background: white; color: green;',
        warn: 'background: orange; color: black;',
        err: 'background: red; color: white;',
      };

      let selected_style = styles[style] + ' padding: 5px';

      // Se ENABLE_CONSOLE_LOGS è true, logga sempre (indipendentemente da production)
      switch (style) {
        case 'std':
        case 'succ':
          console.log(time + ' ' + label, value);
          break;
        case 'info':
          console.log(time + ' %c' + label, selected_style);
          console.log(time + ' %c' + value, selected_style);
          break;
        case 'warn':
          console.warn(time + ' %c' + label, selected_style);
          console.warn(time + ' %c' + value, selected_style);
          break;
        case 'err':
          console.error(time + ' %c' + label, selected_style);
          console.error(time + ' %c' + value, selected_style);
          break;
        default:
          console.log(time + ' %c' + label, selected_style);
          console.log(time + ' %c' + value, selected_style);
          break;
      }
    } catch (error) {
      // In caso di errore, usa console.error standard per evitare ricorsione
      console.error(time + ' Error in Console.log: ' + label, error);
    }
  }
}
